import { IUserEntitiesParam } from 'redux/saga/user/User.types';

export const findEntityIndex = (
  entities: IUserEntitiesParam[],
  caEntityId: string
) => {
  return entities.findIndex((entity) => entity.ca_entity_id === caEntityId);
};

export function isSpoctoDomain(email: string) {
  if (!email) return false;

  const domain = email.split('@').pop();

  return domain?.toLowerCase() === 'spocto.com';
}

export function getYucollectEntity(entities: IUserEntitiesParam[]) {
  if (!entities || entities.length === 0) return -1;

  const checkIIndex = entities.findIndex(
    (entity) =>
      entity?.groups && entity?.groups[0]?.product_code.includes('YUC')
  );
  return checkIIndex;
}
